var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisibility = function SvgVisibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _title || (_title = /*#__PURE__*/React.createElement("title", null, "visibility")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12c2.188 0 4 1.813 4 4s-1.813 4-4 4-4-1.813-4-4 1.813-4 4-4m0 10.688c3.688 0 6.688-3 6.688-6.688s-3-6.688-6.688-6.688-6.688 3-6.688 6.688 3 6.688 6.688 6.688M16 6c6.688 0 12.375 4.125 14.688 10-2.313 5.875-8 10-14.688 10S3.625 21.875 1.312 16C3.625 10.125 9.312 6 16 6"
  })));
};
export default SvgVisibility;